import type { DefaultMinimap as M } from "../maps/DefaultMinimap"
import type { WasmExports } from "../maps/Signatures"

export type WasmPointer<T extends number | bigint> = T & {
  readonly __brand: "Pointer"
}

export type WasmAllocated<T extends number | bigint> = {
  readonly pointer: WasmPointer<T>
  readonly free: () => void
}

type WasmCoreExports<T extends number | bigint> = {
  readonly [M.memory]: WebAssembly.Memory
  readonly [M.__indirect_function_table]: WebAssembly.Table
  readonly [M.malloc]: (size: T) => T
  readonly [M.free]: (ptr: T) => void
}

export type FSInstance<T extends number | bigint> = {
  readonly exports: WasmCoreExports<T>
  readonly conv: (v: number | bigint) => T
  readonly memory64: boolean
}

export type TypedWasmInstance<T extends number | bigint> = {
  readonly exports: WasmExports<T> & WasmCoreExports<T>
  readonly addCallback: (
    fn: (...args: (number | bigint)[]) => number | bigint,
    sig: string
  ) => WasmAllocated<T>
  readonly init: () => Promise<void>
  readonly dispose: () => Promise<void>
  readonly memory64: boolean
  readonly conv: (v: number | bigint) => T
}

export type WasmInstance = TypedWasmInstance<number | bigint>
